import { ntapEnvironment } from '@environments/environment';
import { CoreConfig } from '@ntap/core';
import { AppConfig } from './app-config.interface';
import { SettingsConfigHttpService } from './settings-config-http.service';

export class SettingsConfigService {
  public static setConfig(
    appConfig: AppConfig,
    ntapConfig: CoreConfig,
    settingsService: SettingsConfigHttpService
  ): Promise<AppConfig> {
    return new Promise(function (resolve, reject) {
      try {
        appConfig.apiHost = settingsService.config.apiHost;
        appConfig.waybackHost = settingsService.config.waybackHost;
        appConfig.portalBlHost = settingsService.config.portalBlHost;
        appConfig.wsHost = settingsService.config.wsHost;
        appConfig.crawlingApiHost = appConfig.apiHost + 'web-crawling/';
        appConfig.ntapEnvironment = ntapEnvironment(appConfig.apiHost);
        // override default provided NTAP config
        Object.assign(ntapConfig, appConfig.ntapEnvironment);
        resolve(appConfig);
      } catch (e) {
        reject(e);
      }
    });
  }
}
